import Vue from 'vue';
import App from './App.vue'
import moment from 'moment';
import _ from 'lodash';
import i18n from './i18n/i18n'
import './registerServiceWorker'
import VueCookies from 'vue-cookies';
import Request from './service/request'
import router from './router'
import store from './store'
import Service from './service';
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
import 'default-passive-events'
import '@/styles/import.less'
import commonMixin from './mixins/common'
import Fragment from 'vue-fragment';
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false
Vue.prototype.$Service = Service;
Vue.prototype.$bus = new Vue({})
Vue.prototype.$http = Request
Vue.prototype.$moment = moment;
Vue.prototype.$lodash = _
Vue.use(VueCookies);
Vue.use(VueLazyload, {
  loading: require('@/assets/loading.gif'),
  error: require('@/assets/404.png')
})
Vue.use(Fragment.Plugin);
Vue.mixin(commonMixin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
